<template>
  <section class="first-section-container">
    <div class="bg">
      <div class="coming-soon">
        <p class="title">Coming Soon</p>
        <p class="subtitle">
          The Lambda Chain mainnet will officially launch on May 6th, 
        </p>
        <p class="subtitle">
          at which time the method for claiming airdrops will also be announced.
        </p>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  components: {
    
  },
  computed: {
   
  },
  methods: {
 

  },
};
</script>
<style lang="less" scoped>
.coming-soon {
    width: 100%;
    margin: 0 auto;
    height: 500px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    flex-direction: column;
    p.title {
      font-size: 60px;
      font-weight: 600;
      margin-bottom: 30px;
    }
    p.subtitle {
      font-size: 24px;
    }
}
.first-section-container {
  width: 100%;
  // height: 100vh;
  height: 800px;

  .bg {
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
}

.lda-btn {
    width: 260px;
    height: 60px;
    display: block;
    outline: none;
    border: none;
    font-size: 18px;
    border-radius: 32px;
    text-align: center;
    color: #3f4ae1;
    line-height: 60px;
    font-weight: 300;
    font-weight: bold;
    background: #ffffff;
    cursor: pointer;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    border: 1px solid #ffffff;
  }

  .lda-btn:hover {
    background: linear-gradient(180deg, #ffffff 10%, #b5c8ff 100%);
    color: #101778;
  }

@media (max-width: 500px) {
  .bg {
    background-image: url("../../assets/home/BG.png");
  }

  .first-section {
    padding-top: 157px;

    .mobile-title-wrapper {
      display: block;

      .logo-warpper {
        margin-bottom: 1rem;

        img {
          max-width: 320px;
        }
      }

      .title2 {
        text-align: center;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        line-height: 28px;
      }
      .title3 {
        margin-top: 40px;
        text-align: center;
        margin-bottom: 0;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        // font-weight: 200;
        color: rgba(255, 255, 255, 1);
        line-height: 22px;
      }

      .dencun {
        font-size:22px;
        margin-top: 30px;
        text-align: center;
        margin-bottom: 0;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 200;
        color: rgba(255, 255, 255, 1);
        line-height: 22px;

        .info {
          font-size: 14px;
          line-height: 22px;
          margin:20px 0;
        }
      }


      .btn-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 50px;

        button {
          cursor: pointer;
          color: #3f4ae1;
          outline: none;
          border: 1px solid transparent;
          width: 136px;
          height: 45px;
          background: #ffffff;
          border-radius: 34px;
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 400;
          line-height: 18px 
        }
        button:hover{
          transform: scale(1.04)
        }

        .bg-button {
          background: linear-gradient(108deg, #3f4ae1 100%, #6d43c6 100%);
          margin-right: 32px;
          border: 1px solid #ffffff;
          color: #ffffff
        }
      }

      .announce {
        text-align: center;
        margin-top: 100px;
      }
    }

    .pc-title-wrapper {
      display: none;
    }
  }
}

@media (min-width: 501px) {

  // .first-section-container {
  //   height: 854px;
  // }
  .bg {
    background-image: url("../../assets/home/BG.png");
  }

  .first-section {
    position: relative;
    padding-top: 120px;

    .mobile-title-wrapper {
      display: none;
    }

    .pc-title-wrapper {
      display: block;

      .logo-warpper {
        margin-bottom: 1rem;

        img {
          max-width: 300px;
        }
      }

      .title2 {
        text-align: center;
        margin-bottom: 0;
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
        line-height: 42px;
      }

      .title3 {
        margin-top: 40px;
        text-align: center;
        margin-bottom: 0;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        // font-weight: 200;
        color: rgba(255, 255, 255, 1);
        line-height: 22px;
      }

      .btn-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 50px;

        button {
          cursor: pointer;
          color: #3f4ae1;
          outline: none;
          border: 1px solid transparent;
          width: 136px;
          height: 45px;
          background: #ffffff;
          border-radius: 34px;
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 400;
          line-height: 18px 
        }
        button:hover{
          transform: scale(1.04)
        }

        .bg-button {
          background: linear-gradient(108deg, #3f4ae1 100%, #6d43c6 100%);
          margin-right: 32px;
          border: 1px solid #ffffff;
          color: #ffffff
        }
      }

      .dencun {
        font-size:42px;
        margin-top: 50px;
        text-align: center;
        margin-bottom: 0;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 200;
        color: rgba(255, 255, 255, 1);
        line-height: 42px;

        .info {
          font-size: 24px;
          line-height: 28px;
          margin:30px 0;
        }
      }
      .announce {
        text-align: center;
        margin-top: 100px;
      }
    }
  }
}

@media (min-width: 1025px) and (max-width: 1443px) {
  .first-section {
    padding-top: 200px;
  }
}

@media (min-width: 700px) and (max-width: 1024px) {
  .bg {
    background-image: url("../../assets/home/BG.png");
  }

  .first-section {
    padding-top: 150px;
  }
}

.flip-card{
  .flip-card__top {
    color: white !important;
  }
}


</style>